import { Apple, Dumbbell, Moon, Snowflake, Wind, HeartHandshake } from "lucide-react";

export const AREA_META = {
  nutrition: { icon: Apple, color: "#3B604E", group: "pillars", tint: "#EAF0EC" },
  exercise: { icon: Dumbbell, color: "#3F6E85", group: "pillars", tint: "#EAF0EC" },
  sleep: { icon: Moon, color: "#4A5B7A", group: "pillars", tint: "#EAECF2" },
  cold: { icon: Snowflake, color: "#3E7CA6", group: "corollaries", tint: "#E7F0F5" },
  breathing: { icon: Wind, color: "#8A6D3B", group: "corollaries", tint: "#F5EFE3" },
  relationships: { icon: HeartHandshake, color: "#C81D6B", group: "corollaries", tint: "#FBE4EF" },
};

export const BADGE_LABELS = {
  first_log: { it: "Primo giorno", en: "First day", emoji: "🌱" },
  streak_3: { it: "3 giorni di fila", en: "3-day streak", emoji: "🔥" },
  full_week: { it: "Settimana completa", en: "Full week", emoji: "🏆" },
  perfect_day: { it: "Giornata perfetta", en: "Perfect day", emoji: "⭐" },
};
